import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteInformation } from './actions';
import { getInformations } from './reducer';
import { hasMutation } from './utils';

class InformationList extends Component {
  deleteInformation = id => {
    this.props.deleteInformation(id, 'cs');
  };

  renderTable = () => {
    const { informations } = this.props;

    return informations.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.header.cs : hasEn ? item.header.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs
                  ? `/informace/edit/${item.id}/cs`
                  : `/informace/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn
                  ? `/informace/edit/${item.id}/en`
                  : `/informace/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { informations } = this.props;

    if (informations.length === 0) {
      return <div>Seznam služeb je prázdný</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    informations: getInformations(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteInformation }
)(InformationList);



// WEBPACK FOOTER //
// ./src/modules/InformationList/index.js